import React from "react"
import Profile from "./components/profile"
import Auth from "./components/auth"
import SheetExport from "./components/sheetExport"

export default class ExportGoogleSheet extends React.Component{
    constructor(props){
      super(props)
      this.state = {
        name: "",
        email: "",
        loggedin: false
      }
    }

    onSignIn(user){
      let profile = user.getBasicProfile();
      this.setState({
        name: profile.getName(),
        email: profile.getEmail(),
        loggedin: true
      })
    }

    onFailure(){
      alert("Something went wrong!")
    }

    onLogout(){
      this.setState({
        loggedin: false,
        name: "",
        email: ""
      })
    }

    render(){
      return (
        <div style={{display: "flex", alignItems: "center", margin: 64, flexDirection: "column"}}>
          <div style={{display: "flex", flexDirection: "row"}}>
            <Profile name={this.state.name} email={this.state.email}></Profile>
            <Auth onSignIn={(user) => this.onSignIn(user)} onFailure={() => this.onFailure()} onLogout={() => this.onLogout()} ></Auth>
          </div>

          <SheetExport data={this.props.data} getData={this.props.getData} style={{display: !this.state.loggedin ? "none" : "inherit"}}></SheetExport>
        </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/components/export-google-sheet/index.js